<template>
<div class="chapter">
<div class="inner_page">
<p class="author"><a id="page_iii"></a><strong>Richard J. LEIDER</strong><br/><strong>Alan M. WEBBER</strong></p>
<h1 class="h1" id="ch00_fm02_title">Life Reimagined</h1>
<p class="subtitle"><strong>Discovering Your New Life Possibilities</strong></p>
<p class="publisher"><img alt="image" src="images/pub.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm02_title.vue?43da632e